import { MapMarkersTypeEnum } from '@app/core/enums/map/map-markers-type.enum';
import { Entity } from '@app/core/model/entities/entity';
import { Expose } from 'class-transformer';

export class MapMarker extends Entity {
  public description: string;
  public organizationId: string;
  public property: string;
  public propertyValueMessage: string;
  public defaultIconMarkerFileName: string;
  public defaultIconSelectedMarkerFileName: string;

  @Expose({name: 'configsList'})
  public configs: (EqualsMapMarkerConfig | RangeMapMarkerConfig)[];

  public type: MapMarkersTypeEnum;
  public order: number;

  @Expose()
  public toString(): string {
    return this.name;
  }
}

export type EqualsMapMarkerConfig = {
  value: string,
  iconMarkerFileName: string,
  iconSelectedMarkerFileName: string
};

export type RangeMapMarkerConfig = {
  valueMin: number,
  valueMax: number,
  iconMarkerFileName: string,
  iconSelectedMarkerFileName: string,
  label: string
};
